import { useEffect } from "react";
import { toast } from "sonner";
import { ExternalLink, Copy } from "lucide-react";
import { capture, EVENTS } from "../../analytics/posthog";
import { attributionQuery } from "../../analytics/attribution";
import { externalBrowserUrl } from "../../lib/inAppBrowser";

const LABEL = { instagram: "Instagram", facebook: "Facebook", messenger: "Messenger" };

function shareUrl() {
  const q = attributionQuery();
  return `${window.location.origin}/auth?mode=register${q ? `&${q}` : ""}`;
}

export function InAppBrowserNotice({ app }) {
  useEffect(() => { capture(EVENTS.inAppBrowserDetected, { app }); }, [app]);

  const openExternal = () => {
    capture(EVENTS.inAppOpenExternal, { app });
    window.location.href = externalBrowserUrl(shareUrl());
  };
  const copy = async () => {
    capture(EVENTS.inAppCopyLink, { app });
    try {
      await navigator.clipboard.writeText(shareUrl());
      toast.success("Enlace copiado. Pégalo en Safari o Chrome.");
    } catch {
      toast.message(shareUrl());
    }
  };

  return (
    <div data-testid="inapp-browser-notice" className="relative mb-3 rounded-xl border border-amber-500/30 bg-amber-500/[0.06] p-3 text-xs text-slate-300">
      <p>
        Estás en el navegador de {LABEL[app] || "la app"}. Google puede bloquear el acceso aquí:
        regístrate con tu email o abre esta página en Safari o Chrome para usar Google.
      </p>
      <div className="mt-2.5 flex gap-2">
        <button type="button" data-testid="inapp-open-browser-button" onClick={openExternal}
          className="inline-flex items-center gap-1.5 rounded-full bg-white/[0.06] px-3 py-1.5 font-medium text-white hover:bg-white/[0.1]">
          <ExternalLink className="h-3.5 w-3.5" /> Abrir en el navegador
        </button>
        <button type="button" data-testid="inapp-copy-link-button" onClick={copy}
          className="inline-flex items-center gap-1.5 rounded-full bg-white/[0.06] px-3 py-1.5 font-medium text-white hover:bg-white/[0.1]">
          <Copy className="h-3.5 w-3.5" /> Copiar enlace
        </button>
      </div>
    </div>
  );
}
